import type { Category } from '@ilteducation/content-ref-data-types';
import { useLocale } from '@/plugins/translation';

const useCategoryTranslation = () => {
  const { t } = useLocale();

  // Prefer a Lokalise key matching the categoryCode, otherwise fall back to the ref-data name so
  // cards still render before any translations are added.
  const getCategoryTitle = (category: Category): string => {
    const translation = t(category.categoryCode) as string;
    if (translation && translation !== category.categoryCode) {
      return translation;
    }
    return category.category || category.categoryCode;
  };

  const getCategoryDescription = (category: Category): string => {
    const key = `materials.${category.categoryCode}_description`;
    const translation = t(key) as string;
    return translation && translation !== key ? translation : '';
  };

  return { getCategoryTitle, getCategoryDescription };
};

export default useCategoryTranslation;
